<template>
<v-card height="calc(100vh - 253px)" flat>
    <v-card-title>
        <v-spacer></v-spacer>
        <h5 style="word-wrap: break-word;">
        Xin vui lòng đợi chuyển đến trang tải về
        </h5>
        <h5 v-if="this.getOS()=='ios'">
        Chọn hệ điều hành thích hợp
        </h5>
        <!-- {{redirectToURL}} -->
        <v-spacer></v-spacer>
        
    </v-card-title>
    <v-card-text class="text-center">
        <p >
        
              <a href="https://apps.apple.com/us/app/trung-s%C6%A1n-elearning/id6753839436" target="_blank" class="mx-2" v-if="os=='ios'">
                <img src="/static/icons/App_Store.png" style="height:47px; width: 150px;">
              </a>
              
              <!-- <a @click="getApple(true)" style=" color: white;  text-decoration:underline;">
                <i><h5>Phiên bản cũ iOs</h5></i>
              </a> -->
              
              <v-divider class="my-4" vertical></v-divider>
              
              <a href="https://play.google.com/store/apps/details?id=vn.trungsoncare.elearning" target="_blank" class="mx-2" v-if="os=='android' || os=='windows'">
                  <img src="/static/icons/google_play_2.png" style="height: 47px; width: 150px;">
              </a>
        </p>
        <v-img width="200px" class="mx-auto"
        src="https://play-lh.googleusercontent.com/6TCa4qz9RtR67J4Zn6ZgdqTYFgqAUN6uYe2CnGCoPWr5UC4hqxlGwUXk0x44Ohm_e3vot2W2OZZ13QT9P6gFhQ=w526-h296-rw"></v-img>

        <v-progress-circular class="my-12d-block"
        :size="100"
        :width="7"
        color="orange"
        indeterminate
        ></v-progress-circular>
    </v-card-text>
</v-card>
</template>

<script>
import http from '@/components/services/http-common';
export default {
    name: "RedirectDownload",
    props: ['id'],
    data(){
        return {
            redirected: false,
            redirectToURL: "",
            os: ""
        }
    },
    methods:{
    
        getOS() {
          const ua = navigator.userAgent || navigator.vendor || window.opera

            if (/android/i.test(ua)) return 'android'
            if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios'
            if (/windows phone/i.test(ua)) return 'windows-phone'
            if (/windows/i.test(ua)) return 'windows'
            if (/mac os x/i.test(ua)) return 'mac'
            if (/linux/i.test(ua)) return 'linux'

          return 'unknown'
        },
        osDownload(forcedOs = "") {
          this.os = this.getOS()
          if(forcedOs) {
            this.os = forcedOs
          }
          try{ 
            if(this.os == 'android' || this.os == 'windows' ) {
              window.location.replace('https://play.google.com/store/apps/details?id=vn.trungsoncare.elearning')
              // window.open('https://play.google.com/store/apps/details?id=vn.trungsoncare.elearning', '_blank')
            }
            if(this.os == 'ios') {
              window.location.replace('https://apps.apple.com/us/app/trung-s%C6%A1n-elearning/id6753839436')
              // window.open('https://apps.apple.com/us/app/trung-s%C6%A1n-elearning/id6753839436', '_blank')
            }
          }catch(e) {
            alert(e)
          }
        },
        
        getApple(isLegacy = false, tab)
        {
            return http.get("employees/apple-download", {
              params: {
                legacy: isLegacy
              }
            }).then(res => {
              tab.location.href = res.data.url
                return 
            })
        },
        redirectTo() {
            if(!this.redirected){
                let url = `qrLinks/redirect/${this.id}`;
                    return http.get(url).then(res=>{
                        this.redirectToURL = res.data;
                        if(!this.redirectToURL.includes("http"))
                        {
                            this.redirectToURL = "http://"+this.redirectToURL;
                        }
                        window.location.href = this.redirectToURL;
                        this.redirected =true;
                })
            }
        }
    },
    mounted(){
      this.osDownload()
        // this.redirectTo();
    }
}
</script>
